<template>
  <div class="StaffManage-list">
    <!-- <GlobalInfoBar
        title="职员列表"
        content="主要管理平台职员账号的新增及编辑"
    /> -->
    <div class="log-type-radio">
      <el-radio-group v-model="logType">
        <el-radio-button label="01">操作日志</el-radio-button>
        <el-radio-button label="02">导表日志</el-radio-button>
      </el-radio-group>
    </div>
    <GlobalChunk
        v-if="logType == '01'"
        icon="search"
        title="筛选查询"
    >
      <div slot="filter">
        <LogFrom />
      </div>
      <LogTable />
    </GlobalChunk>
    <GlobalChunk
        v-if="logType == '02'"
        icon="search"
        title="筛选查询"
    >
      <div slot="filter">
        <ExportForm />
      </div>
      <ExportTable />
    </GlobalChunk>
  </div>
</template>

<script>
import LogFrom from './From'
import LogTable from './Table'
import ExportForm from './formTable/ExportForm.vue'
import ExportTable from './formTable/ExportTable.vue'
export default {
  name: 'StaffManage-list',
  components: {LogFrom,LogTable,ExportForm,ExportTable},
  data(){
    return{
      logType: "01",
    }
  },
  methods:{
  }
}
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.StaffManage-list{
  .log-type-radio{
    margin-bottom: 20px;
  }
}
</style>
